import { URLParameters } from '@/app/common/urlParameters.ts';
import { useTranslation } from '@/app/components/translations/Translation';
import { useCuriosityManager } from '@/app/common/CuriosityManagerProvider.tsx';

import ToggleBanner, { BANNER_TYPES } from '../Toggle';

const OpxFlexibleBanner = () => {
  const { t } = useTranslation();
  const { curiosityClickEvents } = useCuriosityManager();

  const handleToggleBannerOnChange = (isActiveValue: string) => {
    curiosityClickEvents.opxFlexibleBannerClick(isActiveValue);
  };

  return (
    <ToggleBanner
      {...{
        text: t('vacation.oss.opx.banner.flexible'),
        switchText: t('vacation.oss.opx.banner.flexible_toggle'),
        searchParam: URLParameters.FILTER_OPX_FLEXIBLE,
        type: BANNER_TYPES.BASE,
        invertToggle: true,
        handleToggleBannerOnChange,
      }}
    />
  );
};

export default OpxFlexibleBanner;
